import http from '@/utils/http' //引入axios
export const getMachine = data => http.get('/rvm-center/api/machine', {
    params: data
}) //查找条码
export const updataMachine = data => http.put('/rvm-center/api/machine', data) //編輯条码
export const addMachine = data => http.post('/rvm-center/api/machine', data) //添加条码
export const deleteMachine = data => http.delete('/rvm-center/api/machine', {
    params: data
}) //根据Machines刪除条码
export const getMachineById = data => http.get('/rvm-center/api/machine/detail', {
    params: data
}) //根据ID查询machine
export const getAllMachine = () => http.get('/rvm-center/api/machine/findAllMachines')
export const getOwnMachines = () => http.get('/rvm-center/api/machine/findOwnMachines')
// export  const findMachine = data=>http.get('/api/district/superior',{params:data}) //查找部门

// 临时接口（查找设备）
export const getMapInfo = data => http.get(`/map/search?q=${data}&viewbox=113.7662,22.5944,114.5215,22.1162&bounded=1&format=json`, {
    params: data
})
export default {
    getMachine,
    updataMachine,
    addMachine,
    deleteMachine,
    getMachineById,
    getAllMachine,
    getMapInfo,
    getOwnMachines
    // findMachine
}